<ejs-dialog id="ejDialogDownload" #ejDialogDownload (overlayClick)="onOverlayClickOutsideMenu()"
  (beforeClose)="onDialogClose($event)" [visible]="isVisible" header="Download {{noteOrNotebookText}}"
  [animationSettings]='animationSettings' [target]="dialogDragTarget" [allowDragging]='allowDialogDragging'
  [enableResize]='false' isModal="true" [showCloseIcon]='true' [width]="dialogWidth" cssClass="fn-dl-dialog" [zIndex]="99999">
  <ng-template #content>
    <div class="heading">Forensic {{noteOrNotebookText}} (PDF Only)</div>
    <button class="success" [disabled]="busyPackageType !== null" (click)="DownloadNoteOrNotebook(downloadPasswordEntered.value, '1')"><img
      src="/assets/images/progress-spinner.gif" class="button-spinner" alt="" *ngIf="busyPackageType === '1'" />Download PDF
      Only</button>
    <br>
    <hr />
    <br>
    <div class="heading">Forensic {{noteOrNotebookText}} (Full-Disclosure)</div>
    <p>
      ZIP Archive Includes:
    </p>
    <ul>
      <li>Attachments<br>
        (images, videos, documents, etc.)</li>
      <li>Forensics Notes<br>
        (including previous versions)</li>
    </ul>

    <p class="subheading">
      Password Protect ZIP Archive?
    </p>

    <div class="radio-btn" style="min-height:25px">
      <label>
        <input type="radio" value="no" name="question" (change)="Setradio('no');">
        <span class="cricle-r"></span>No
      </label>
    </div>
    <div class="radio-btn" style="min-height:25px">
      <label>
        <input type="radio" value="yes" [checked]='true' name="question" (change)="Setradio('yes');">
        <span class="cricle-r"></span>Yes - Password Protected
      </label>
    </div>
    <div class="input-box row">
      <input type="password" #downloadPasswordEntered id="downloadPasswordEntered" value="{{currentpassword}}" autocomplete="off">

      <div class="popup-l-icon">
        <div class="tooltip icon-b1" (click)="CopyInput(downloadPasswordEntered)">
          <span class="copyd-icon"></span>
          <span class="tooltiptext" id="myTooltip">Copy</span>
        </div>
        <div class="display-inline icon-b1 tooltip" (click)="showHidePassword($event)">
          <span class="eye-icon"></span>
          <span class="tooltiptext" id="myTooltip">Show/Hide Password</span>
        </div>
      </div>
    </div>
    <button class="success" [disabled]="busyPackageType !== null" (click)="DownloadNoteOrNotebook(downloadPasswordEntered.value, '0')"><img
      src="/assets/images/progress-spinner.gif" class="button-spinner" alt="" *ngIf="busyPackageType === '0'" />Download
      Full-Disclosure Package</button>
  </ng-template>
</ejs-dialog>

<app-notebook-download-stepper #notebookStepper></app-notebook-download-stepper>
